import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Table, Icon } from 'antd'
import { popupStore } from 'store'

@inject((store: any) => {
    const { popupStore, collectionsStore } = store
    return { popupStore, collectionsStore }
})
@observer
export default class CollectionClinicServicePopup extends Component<any, any> {
    static PER_PAGE = 5
    updateParam = (name, value) => {
        this.setState(prevState => ({ ...prevState, searchParams: { ...prevState.searchParams, [name]: value } }))
    }
    handlePageChange = page => {
        const { collectionsStore } = this.props
        collectionsStore.changePage(page)
        collectionsStore.getCollectionsByClinic(popupStore.info.clinic_id, page, CollectionClinicServicePopup.PER_PAGE)
    }
    handleFilterChange = async (field, value) => {
        const { collectionsStore } = this.props
        collectionsStore.setFilter(field, value)
        if (value && value.length > 2) {
            collectionsStore.getCollectionsByClinic(popupStore.info.clinic_id, 1, CollectionClinicServicePopup.PER_PAGE)
        }
    }
    resetParams = () => {
        this.setState(prevState => ({
            ...prevState,
            searchParams: {
                clinic_id: popupStore.info.clinic_id,
                page: 1,
                freeText: ''
            }
        }))
    }
    resetFilters = async () => {
        const { collectionsStore } = this.props
        await collectionsStore.resetFilters()
        collectionsStore.getCollectionsByClinic(popupStore.info.clinic_id, 1, CollectionClinicServicePopup.PER_PAGE)
    }

    handleSearch = async () => {
        const { collectionsStore } = this.props
        collectionsStore.getCollectionsByClinic(popupStore.info.clinic_id, 1, CollectionClinicServicePopup.PER_PAGE)
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, collectionsStore } = this.props
        const { list, filters, setFilter, paging, loading } = collectionsStore
        const columns = [
            {
                title: 'זכות מזהה',
                key: 'collection_id',
                align: 'right',
                render: (_, obj) => (
                    <>
                        <a
                            style={{ textDecoration: 'underline', color: 'black' }}
                            href={`/collection-terms/${obj.collection_id}`}
                            target="_blank"
                        >
                            {obj.collection_id}
                        </a>
                    </>
                )
            },
            {
                title: 'תחום שירות',
                key: 'name',
                align: 'right',
                render: (_, obj) => {
                    const listItems = obj.collectionClinicsService.map(item => <li>{item.name}</li>)
                    return <ul style={{ listStyleType: 'none' }}>{listItems}</ul>
                }
            },
            {
                title: 'שם זכות',
                key: 'collection_name',
                align: 'right',
                render: (_, obj) => <span>{obj.collection_name}</span>
            }
        ]
        return (
            <Modal
                title={'סוגי שירותים של מרפאה'}
                visible={popupStore.popupType === 'collection_clinicServicesList'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                width={600}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <div style={{ display: 'flex', marginBottom: '1rem' }}>
                        <Input.Search
                            placeholder="חיפוש על פי שם זכות או מזהה"
                            value={filters.freeText ? filters.freeText : null}
                            onChange={e => setFilter('freeText', e.target.value)}
                        />
                        <Input.Search
                            placeholder="חיפוש על מזהה"
                            value={filters.collection_id ? filters.collection_id : null}
                            onChange={e => setFilter('collection_id', e.target.value)}
                        />
                        <div style={{ display: 'flex' }}>
                            <Button style={{ margin: '0 0.2rem' }} onClick={() => this.resetFilters()}>
                                איפוס
                            </Button>
                            <Button style={{ margin: '0' }} onClick={() => this.handleSearch()} type="primary">
                                חפש
                            </Button>
                        </div>
                    </div>
                    <Table
                        className="center-table"
                        style={{ width: '100%' }}
                        rowKey="id"
                        loading={loading}
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            total: paging.total,
                            pageSize: Number(paging.perPage),
                            current: Number(paging.page)
                        }}
                        onChange={e => this.handlePageChange(e.current)}
                    />
                </div>
            </Modal>
        )
    }
}
